import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import PatientList from "../components/ProviderListing";
import { getMasterServiceProvider } from "../../../actions/Master";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  masterServiceProviderState,
}: ApplicationState) => ({
  masterServiceProviderState: masterServiceProviderState.response,
  serviceProviderList: masterServiceProviderState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getMasterServiceProvider: () => {
      dispatch(getMasterServiceProvider());
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientList);
